import $ from 'jquery';

$(document).ready(function() {
    let text = '';
    $(document).on('click', '.js-calendar-time-item', function() {
        $('.js-calendar-time-item').removeClass('active');
        $(this).addClass('active');
        text = $(this).attr('data-calendar-time');
        $('.js-calendar-time-title').text(text);
    });
    $(document).on('click', '.js-calendar-time-all', function() {
        $('.js-calendar-filter-chosen-item').remove();
        $('.js-calendar-filter-inner-item').removeClass('active');
        $('.js-calendar-filter-item').removeClass('chosen');
        $('.js-calendar-filter-chosen-reset').removeClass('show');
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/calendar/calendar-time.js